import type { Money } from "@/lib/domain/Money";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface DashboardCurrentPositionResponseModel {
	readonly marketValue: Money;
	readonly invested: Money | null;
	readonly cashPosition: Money | null;
	readonly gain: Money | null;
	readonly profit: Money | null;
}

export const useDashboardCurrentPosition = () => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["dashboardCurrentPosition"],
		queryFn: () => http<DashboardCurrentPositionResponseModel>({
			method: "GET",
			url: "/collection/dashboard/current-position"
		})
	});
};
